function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n\n  input ~ .CheckboxField-Checkmark {\n    border: solid 1px #ddd;\n  }\n\n  input:checked ~ .CheckboxField-Checkmark {\n    background-color: ", ";\n    border: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { FieldBase } from "./FieldBase";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import "./CheckboxField.css";
var StyledLabel = styled.label(_templateObject(), function (props) {
  return props.color;
}, function (props) {
  return props.color;
}); // #region HOOK

/**
 * Représente une checkbox
 * @class
 * @category Fields
 * @param {Fields.CheckboxField.propTypes} props Les propriétés du champ
 */

function CheckboxField(props) {
  // Récupération des props
  var name = props.name,
      textColor = props.textColor,
      tooltip = props.tooltip,
      readonly = props.readonly,
      value = props.value;
  return /*#__PURE__*/React.createElement(FieldBase, _extends({}, props, {
    render: function render(handleChange) {
      return /*#__PURE__*/React.createElement(StyledLabel, {
        color: textColor,
        className: "CheckboxField-Container"
      }, tooltip, /*#__PURE__*/React.createElement("input", {
        name: name,
        type: "checkbox",
        checked: value ? true : false,
        onChange: readonly ? function () {} : handleChange
      }), /*#__PURE__*/React.createElement("span", {
        className: "CheckboxField-Checkmark"
      }));
    }
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link CheckboxField}
 * @typedef {Object} CheckboxField.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le texte du champ
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {boolean} [value=false] L'état de la case à cocher
 * @property {string} [icon=null] L'icône à afficher
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {Function} [onClickIcon=null] La fonction de callback de l'évènement onClick du bouton
 * @property {Function} [onMouseEnterIcon=null] La fonction de callback de l'évènement onMouseEnter de l'icône
 * @property {boolean} [obligatory=false] true si le champ est obligatoire
 * @property {boolean} [readonly=false] true si le champ est désactivé
 */


CheckboxField.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  value: PropTypes.bool,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onMouseEnterIcon: PropTypes.func,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool
} : {};
/*
  Valeurs par défaut des propriétés
*/

CheckboxField.defaultProps = {
  width: "100%",
  backgroundColor: "#fff",
  textColor: "#000",
  value: false,
  icon: null,
  keepSpaceIcon: false,
  onClickIcon: null,
  onMouseEnterIcon: null,
  obligatory: false,
  readonly: false
}; // #endregion

export { CheckboxField };